import { HasAuthUserMixin } from '/@/modules/core/app/mixins/HasAuthUserMixin';
import { HasCurrentEstateMixin } from '/@/modules/core/app/mixins/HasCurrentEstateMixin';
import ceLogo from '/@/assets/logos/logo.svg';
import ceLogoResponsive from '/@/assets/logos/logo-responsive.png';
import cdLogo from '/@/assets/logos/cleardesk-logo.svg';
import cdLogoResponsive from '/@/assets/logos/cleardesk-logo-responsive.png';

export default {
  mixins: [HasAuthUserMixin, HasCurrentEstateMixin],
  computed: {
    estateCompany() {
      return this.currentEstate?.company;
    },
    professionalCompany() {
      return this.authUser?.company;
    },
    logo() {
      if (this.estateCompany?.fullLogoPath) {
        return this.currentEstate.company.fullLogoPath;
      }
      if (this.professionalCompany?.isPartner && this.professionalCompany?.fullLogoPath) {
        return this.professionalCompany.fullLogoPath;
      }
      if (!!this.authUser?.isStaff && !this.authUser?.isViewingEstate) {
        return cdLogo;
      }

      return ceLogo;
    },
    logoResponsive() {
      if (this.estateCompany?.responsiveFullLogoPath) {
        return this.estateCompany.responsiveFullLogoPath;
      }
      if (this.professionalCompany?.isPartner && this.professionalCompany?.responsiveFullLogoPath) {
        return this.professionalCompany.responsiveFullLogoPath;
      }
      if (!!this.authUser?.isStaff && !this.authUser?.isViewingEstate) {
        return cdLogoResponsive;
      }

      return ceLogoResponsive;
    },
    isPoweredBy() {
      return !!(
        this.professionalCompany?.hasCustomLogo ||
        (this.estateCompany?.isPartner && this.estateCompany?.hasCustomLogo)
      );
    }
  }
};
